/* eslint-disable react-refresh/only-export-components */
import isEmpty from "lodash/isEmpty";
import { ManageRolesTableDataItem } from "PFApp/activities/manage_roles/manage_roles.types";
import { EmptyCell } from "PFApp/activities/manage_roles/parts/empty_cell";
import { ProfileInfo } from "PFApp/activities/manage_roles/parts/profile_info";
import { RolesFormKey } from "PFApp/types/activity_form/activity_form_schema";
import { ManageRolesMultiForm, WMProfile } from "PFApp/types/activity_form/manage_roles_form_schema";
import { Stack } from "PFComponents/containers";
import { ColumnHelper } from "PFComponents/table/table.types";
import { useWatch } from "react-hook-form";

import css from "./cell.module.scss";

const READONLY_WM_COLUMN_WIDTH = 150;

type ReadonlyWmFieldName = "original_wm" | "booked_wm";

type ReadonlyWmCellProps = {
  rolesFormKey: RolesFormKey;
  rowIndex: number;
  fieldName: ReadonlyWmFieldName;
  qaId: string;
};

const ReadonlyWmCell = ({ rolesFormKey, rowIndex, fieldName, qaId }: ReadonlyWmCellProps) => {
  const name = `${rolesFormKey}.${rowIndex}.${fieldName}` as const;
  const profiles = useWatch<ManageRolesMultiForm>({ name }) as WMProfile[] | undefined;

  if (isEmpty(profiles)) {
    return <EmptyCell qaId={qaId} />;
  }

  return (
    <Stack className={css.cell} qaId={qaId}>
      {(profiles ?? []).map((profile) => (
        <ProfileInfo key={profile.id} profile={profile} />
      ))}
    </Stack>
  );
};

type CreateReadonlyWmColumnParams = {
  columnHelper: ColumnHelper<ManageRolesTableDataItem>;
  rolesFormKey: RolesFormKey;
  headerLabel: string;
  fieldName: ReadonlyWmFieldName;
  qaId: string;
};

export const createReadonlyWmColumn = ({
  columnHelper,
  rolesFormKey,
  headerLabel,
  fieldName,
  qaId
}: CreateReadonlyWmColumnParams) =>
  columnHelper.accessor((row) => row, {
    id: fieldName,
    header: () => <span>{headerLabel}</span>,
    cell: (info) => (
      <ReadonlyWmCell
        rolesFormKey={rolesFormKey}
        rowIndex={info.row.index}
        fieldName={fieldName}
        qaId={qaId}
      />
    ),
    size: READONLY_WM_COLUMN_WIDTH,
    meta: {
      getIsCopyPasteBlocked: () => true
    }
  });
